import { useQuery } from '@apollo/client';
import { APPLICATION_STATUS_FOR_APPLICATION_TYPE } from '@application/constants';
import type { ApplicationType } from '@application/types';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type {
  AccountGetBreederApplicationsQuery,
  AccountGetBreederApplicationsQueryVariables,
} from '@gql/graphql';
import { SortOrder } from '@gql/graphql';

export const ACCOUNT_GET_BREEDER_APPLICATIONS = graphql(`
  query AccountGetBreederApplications(
    $breedTranslationsWhere: DogBreedTranslationWhereInput
    $orderBy: DogBreederApplicationOrderByWithRelationAndSearchRelevanceInput
    $where: DogBreederApplicationWhereInput
  ) {
    accountMe {
      id
      dogBreeder {
        id

        breederBreeds {
          id
          dogBreedId
        }

        applications(where: $where, orderBy: $orderBy) {
          id
          createdAt
          status
          seenByBreeder

          breedPreference {
            id
            translations(where: $breedTranslationsWhere) {
              id
              name
            }
            imgs(take: 1, where: { type: { equals: COVER } }) {
              id
              small
            }
          }

          animal {
            id
            birthday
          }

          account {
            id
            firstName
            lastName
            imgs(take: 1) {
              id
              small
            }
          }
        }
      }
    }
  }
`);

export interface UseGetBreederApplicationsParams {
  archived: boolean;
  type: ApplicationType;
}

export const useGetBreederApplications = (params: UseGetBreederApplicationsParams) => {
  const { type } = params;

  const { language } = useRouter();

  const { data, loading } = useQuery<
    AccountGetBreederApplicationsQuery,
    AccountGetBreederApplicationsQueryVariables
  >(ACCOUNT_GET_BREEDER_APPLICATIONS, {
    variables: {
      breedTranslationsWhere: { language: { equals: language } },
      where: {
        archived: { equals: params.archived },
        status: { in: APPLICATION_STATUS_FOR_APPLICATION_TYPE[type] },
      },
      orderBy: {
        createdAt: SortOrder.desc,
      },
    },
    ssr: false,
    fetchPolicy: 'no-cache',
  });

  return {
    applications: data?.accountMe?.dogBreeder?.applications ?? [],
    applicationsBreeder: data?.accountMe?.dogBreeder,
    applicationsLoading: loading,
  };
};
